'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var styles = require('@material-ui/styles');
var AppsIcon = require('@material-ui/icons/AppsRounded');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var AppsIcon__default = /*#__PURE__*/_interopDefaultLegacy(AppsIcon);

var useStyles = styles.makeStyles(theme => ({
  appBar: {
    position: 'fixed',
    top: 0,
    height: 48,
    left: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.common.white,
    zIndex: theme.zIndex.drawer + 1,
    boxShadow: 'none',
    boxSizing: 'border-box' // borderBottom: `1px solid ${theme.palette.divider}`,

  },
  logoLink: {
    height: 36,
    marginLeft: 6,
    cursor: 'pointer'
  },
  textLink: _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, theme.typography.h1), {}, {
    cursor: 'pointer',
    textDecoration: 'none',
    color: theme.palette.primary.dark,
    marginLeft: 6
  }),
  appsIcon: {
    fontSize: 24,
    marginRight: 8
  },
  logo: {
    height: '100%',
    width: 'auto'
  },
  icon: {
    marginBottom: 0
  }
}));
/**
 * Desktop App Bar
 */

function MobileAppBar(_ref) {
  var {
    children,
    logo,
    brandName,
    homeLink,
    userMenu
  } = _ref;
  var classes = useStyles();
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.appBar
  }, logo ? /*#__PURE__*/React__default['default'].createElement("a", {
    href: homeLink,
    className: classes.logoLink
  }, /*#__PURE__*/React__default['default'].createElement("img", {
    alt: brandName,
    src: logo,
    className: classes.logo
  })) : /*#__PURE__*/React__default['default'].createElement("a", {
    href: homeLink,
    className: classes.textLink
  }, /*#__PURE__*/React__default['default'].createElement("span", null, /*#__PURE__*/React__default['default'].createElement(AppsIcon__default['default'], {
    className: classes.appsIcon
  })), brandName), children, /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      flex: 1
    }
  }), userMenu);
}
MobileAppBar.propTypes = {
  children: index.node,
  logo: index.string,
  brandName: index.string,
  homeLink: index.string,
  userMenu: index.node
};

exports.MobileAppBar = MobileAppBar;
